import { Base } from './base.model';
import { Type } from "../decorators/type.decorator";
import { Region } from "./region.model";
import { AcrReportingPeriod } from "./acr-reporting-period.model";

export class AcrProject extends Base {
  public regionId: number;
  public marketRate: number;
  @Type(Region) public region: Region;
  public projectName: string;
  public projectId: string;
  public methodology: string;
  public monthsInRp: string;
  public startDate: Date;
  @Type(AcrReportingPeriod) public reportingPeriods: AcrReportingPeriod[];
}
